import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { format } from "../../../utils/format";
import { Dinero } from "../../../utils/money";

import styles from "./common.module.scss";

export const SubtitleRow = (
    props: Immutable<{
        retailSubtotalIncludingAddons: Dinero;
    }>,
): React.ReactNode => (
    <span className={styles.line}>
        <li className={styles.regular}>{t`Subtotal`}</li>
        <li className={styles.regular}>
            {format.money(props.retailSubtotalIncludingAddons)}
        </li>
    </span>
);
